import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Banner from "../../components/Banner/Banner";
import Main from "../../components/Main/_index";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";
import Showcase from "../../components/Showcase/Showcase";

const Templates = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <>
      <Main
        backimg="/img/templatesback.jpg"
        title={translations[selectedLanguages]?.templatesMain.title}
        context={translations[selectedLanguages]?.templatesMain.context}
      />
      <Showcase />
      <Outlet />
      <Banner />
    </>
  );
};

export default Templates;
